module.exports = __webpack_public_path__ + "static/media/gothic-rasturant.2dfa8e90.jpg";